var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityCreateKit = function SvgActivityCreateKit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.65 22.79"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.49 4.35A8.78 8.78 0 0 0 11.86 2H5.8a8.74 8.74 0 0 0 1.36 2.35ZM10.52 6.35H7.14C5.41 8.11 2.94 11 2.21 13.69h13.23c-.72-2.69-3.19-5.58-4.92-7.34Z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 13.69c-.62-3-3-6.07-5.22-8.39A8.89 8.89 0 0 0 14.12 1V0H3.53v1a8.89 8.89 0 0 0 1.84 4.3C3.15 7.62.78 10.68.16 13.69A7.22 7.22 0 0 0 0 15.14c0 4.22 4 7.65 8.83 7.65s8.83-3.43 8.83-7.65a7.22 7.22 0 0 0-.17-1.45ZM11.86 2a8.78 8.78 0 0 1-1.37 2.35H7.16A8.74 8.74 0 0 1 5.8 2ZM7.14 6.35h3.38c1.73 1.76 4.2 4.64 4.92 7.33H2.21c.73-2.68 3.2-5.57 4.93-7.33Z",
    style: {
      fill: "#632245"
    }
  }))));
};
export default SvgActivityCreateKit;